import { object, number, boolean, array, string } from '@gogame/schemas';

import { breakdownPathSchema } from './breakdownPathSchema';
import { chartsSchema } from './chartsSchema';
import { cohortsSettingsSchema } from './cohortsSettingsSchema';
import { columnsSchema } from './columnsSchema';
import { drillPathSchema, nextDimensionSchema } from './drillPathSchema';
import { filtersCollectionSchema } from './filtersSchema';
import { organicSettingsSchema } from './organicSettingsSchema';
import { tableSettingsSchema } from './tableSettingsSchema';

export const screenSchema = object({
  breakdownPath: breakdownPathSchema,
  filtersCollection: filtersCollectionSchema,
  tableSettings: tableSettingsSchema,
  drillPath: drillPathSchema,
  nextDimension: nextDimensionSchema,
  charts: chartsSchema,
  columns: columnsSchema,
  advancedFilters: array(string()).default([]),
  dimensionSearchQuery: string().default(''),
  presentedRows: array(string()).default([]),
  cohortsSettings: cohortsSettingsSchema,
  presetId: number(),
  ready: boolean().default(false),
  organic: organicSettingsSchema,
});

export const mapPresetToState = (presetData) =>
  screenSchema.cast(presetData, { parseConst: true, context: {} });
